import React from "react";

/**
 * DS QuickDateGroup — 어제/전체/오늘/7일/1개월/6개월/1년 등 빠른 날짜 선택.
 * Figma "Frame 59" 그룹.
 *
 * @param {object} props
 * @param {Array<{value: string, label: string}>} props.options
 * @param {string} [props.activeValue]
 * @param {(value: string) => void} props.onChange
 * @param {string} [props.className]
 */
const DSQuickDateGroup = ({ options = [], activeValue, onChange, className = "" }) => {
  return (
    <div className={`ds-quick-date ${className}`}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`ds-quick-date__cell ${
            activeValue === opt.value ? "ds-quick-date__cell--active" : ""
          }`}
          onClick={() => onChange && onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default React.memo(DSQuickDateGroup);
